import React, { Fragment } from "react";
import "./product-row-header.css";
const ProductRowHeader = ({ Title, moreTitle }) => {
  return (
    <Fragment>
      <div className="container-fluid row_header_body">
        <div className="row row_header_main">
          <div className="col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6 row_header_link">
            {moreTitle ? (
              <div>
                <i className="uil uil-angle-double-left"></i>

                <span style={{ cursor: "pointer" }}>دیدن همه</span>
              </div>
            ) : null}
          </div>
          <div className="col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6 row_header_title ">
            <h4>{Title}</h4>
          </div>
        </div>
        <div className="row row_header_line">
          <div className="header_main_line"></div>
          <div className="header_border_line"></div>
        </div>
      </div>
    </Fragment>
  );
};

export default ProductRowHeader;
